import HoursConfig from './HoursConfig.view';

export default HoursConfig;
